import React from 'react';
import { INIT_STATE } from './reducer';

export const PaymentGatewayContext = React.createContext({
  pgState: INIT_STATE,
  reducerDispatch: {},
});
